<template>
    <div class="profile-form">
        <b-form @submit.prevent="profileSubmit">
            <div class="alert alert-info">Es werden nur die Daten geändert, die Sie erneut angeben</div>
            <validation-input :disabled="formDisabled" id="email" label="E-Mail" v-model="profile.email" :validation="validation" type="text" autocomplete="email"/>
            <b-form-group label="Name" label-for="name">
                <b-form-input type="text" :disabled="formDisabled" v-model="profile.name" name="name"/>
            </b-form-group>
            <b-form-group label="Adresse" label-for="address">
                <b-form-input type="text" :disabled="formDisabled" autocomplete="address" v-model="profile.address" name="address"/>
            </b-form-group>
            <validation-input :disabled="formDisabled" id="postalCode" label="PLZ" v-model="profile.plz" :validation="validation" type="text"/>
            <b-form-group label="Profilbild" label-for="profileImage">
                <b-avatar :src="imageSrc" class="mr-3"/>
                <b-form-file v-model="image" :disabled="formDisabled" id="profileImage" accept="image/jpeg, image/png, image/gif" placeholder="Wählen Sie eine Datei"
                             drop-placeholder="Ziehen Sie das Bild hierhin..."/>
            </b-form-group>


            <b-form-invalid-feedback id="postalcode-error">
                Muss genau 5 Zeichen haben
            </b-form-invalid-feedback>
            <b-button variant="outline-primary" v-on:click="editButtonClicked">{{editButtonMessage}}</b-button>
            <b-button variant="primary" type="submit" :disabled="formDisabled">Aktualisieren</b-button>
        </b-form>
    </div>
</template>

<script>

    import {userService} from "../services/user.service";
    import {imageService} from "../services/image.service";
    import ValidationInput from "./shared/ValidationInput";

    const BUTTON_EDIT = "Bearbeiten";
    const BUTTON_CANCEL = "Abbrechen";


    export default {
        name: 'Profile',
        components: {
            ValidationInput
        },
        data() {
            return {
                formDisabled: true,
                originalProfile: {},
                profile: {
                    name: "",
                    email: "",
                    address: "",
                    plz: "",
                    profilePicture: 1
                },
                validation: {
                    submitted: false,
                    username: {
                        dirty: false,
                        required: true
                    },
                    email: {
                        dirty: false,
                        required: true,
                        email: true,
                        requiredMessage: "Bitte E-Mail angeben"
                    },
                    postalCode: {
                        dirty: false,
                        required: false,
                        minLength: 5,
                        maxLength: 5,
                        minLengthMessage: "Bitte eine 5-Stellige Postleitzahl angeben",
                        maxLengthMessage: "Bitte eine 5-Stellige Postleitzahl angeben"
                    }
                },
                image: null,
                imageSrc: "",
                editButtonMessage: BUTTON_EDIT
            }
        },
        watch: {
            image(newValue, oldValue) {
                if (newValue !== oldValue) {
                    if (newValue) {
                        imageService.base64Encode(newValue)
                            .then(value => {
                                this.imageSrc = value;
                            })
                            .catch(() => {
                                this.imageSrc = null;
                            });
                    } else {
                        this.imageSrc = null;
                    }
                }
            }
        },
        created() {
            this.initialSetup()
        },
        methods: {
            editButtonClicked() {
                if (this.formDisabled) {
                    this.formDisabled = false;
                    this.editButtonMessage = BUTTON_CANCEL;
                } else {
                    this.initialSetup();
                }
            },
            profileSubmit() {
                if ((this.profile.plz.length !== 0 && this.profile.plz.length !== 5) || this.profile.email.length === 0) {
                    this.validation.submitted = true;
                    return;
                }
                const changedValues = this.getChangedValues();
                if (Object.keys(changedValues).length === 0 && !this.image) {
                    this.$root.$bvToast.toast(`Es wurden keine neuen Daten eingegeben`, {
                        title: 'Das Profil wurde nicht geändert',
                        autoHideDelay: 5000,
                        variant: "warning"
                    });
                    return;
                }
                if (this.image) {
                    if (this.profile.profilePicture > 1) {
                        imageService.overwriteImage(this.profile.profilePicture, this.image, this.imageSrc)
                            .then(() => this.handleSubmitSuccess())
                            .catch(() => this.handleSubmitError())

                    } else {
                        imageService.addImage(this.image, this.imageSrc)
                            .then(res => {
                                changedValues.profilePicture = res.items[0];
                                userService.updateProfile(changedValues)
                                    .then(() => this.handleSubmitSuccess())
                                    .catch(() => this.handleSubmitError())
                            })
                            .catch(() => this.handleSubmitError())

                    }
                } else {
                    userService.updateProfile(changedValues)
                        .then(() => this.handleSubmitSuccess())
                        .catch(() => this.handleSubmitError())
                }

            },
            getChangedValues() {
                let changed = {};
                Object.keys(this.originalProfile).forEach((key) => {
                    if (this.originalProfile[key] !== this.profile[key]) {
                        changed[key] = this.profile[key];
                    }
                });
                return changed;
            },
            handleSubmitSuccess() {
                this.$root.$bvToast.toast(`Eingegebende Daten wurden hinterlegt`, {
                    title: 'Erfolgreich geändert',
                    autoHideDelay: 5000,
                    variant: "success"
                });
                this.initialSetup();
            },
            handleSubmitError() {
                this.$bvToast.toast(`Fehler`, {
                    title: 'Beim speichern des Profils ist ein Fehler aufgetreten',
                    autoHideDelay: 5000,
                    variant: "info"
                })
            },
            initialSetup() {
                this.validation.submitted = false;
                this.formDisabled = true;
                this.editButtonMessage = BUTTON_EDIT;
                userService.getProfile().then(res => {
                    if (res.profile.plz.toUpperCase() === 'NONE') {
                        res.profile.plz = "";
                    }
                    this.originalProfile = JSON.parse(JSON.stringify(res.profile));
                    this.profile = res.profile;
                    if (this.profile.profilePicture !== 1) {
                        imageService.getImage(this.profile.profilePicture)
                            .then(resp => this.imageSrc = resp.path);
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .profile-form {
        width: 340px;
        margin: 50px auto;
    }
</style>

